/**
 * @module: 我的投递store
 * @author: Teacher Tang
 * @date: 2019-09-29 14:00:00
 */

import { observable, action } from 'mobx';
import format from '@src/utils/format';
import moment from 'moment';
import ywk from '@clouderwork/ywk';

const thisweek = format.getStartEnd('week');
interface Itime {
  start_datetime: string;
  end_datetime: string;
}

const weekOfDay = moment().format('E');

class Stats {
  constructor() {
    const start = ywk.utils.getQueryString('start');
    const end = ywk.utils.getQueryString('end');
    let diff = 0;
    if (start && end) {
      diff = moment().diff(moment(start), 'weeks');
      this.setWeekIndex(diff);
    }
  }

  @observable appLoading: boolean = false;
  // 更新时间
  @observable timeStr: string = '';
  @observable weekData: any[] = [];
  // 当前激活的tab，默认是0代表周，否则是日
  @observable curTab: number = 0;
  // 默认选中本周的值
  @observable weekIndex: number = 0;
  @observable weeks: { name: string; start: string; end: string } = {
    name: '本周',
    start: thisweek[0],
    end: thisweek[1]
  };
  // 默认选中今天的值
  @observable dayIndex: number = 0;
  @observable days: { name: string; val: string } = {
    name: `${moment().format('MM-DD')} 今天`,
    val: moment().format('YYYY-MM-DD')
  };
  // 绩效报告
  @observable reportDay: string = '';
  // 是否显示更多未使用用户
  @observable showNoUse: boolean = false;
  // 是否显示更多活跃用户
  @observable showActive: boolean = false;
  @observable selectTime: Itime = {
    start_datetime: moment()
      .subtract(+weekOfDay - 1, 'days')
      .format('YYYY-MM-DD'), // todo lhl 默认按周
    // start_datetime: '2021-10-18',
    end_datetime: moment()
      .add(7 - +weekOfDay, 'days')
      .format('YYYY-MM-DD')
  };

  @action.bound
  setSelectTime(data: Itime) {
    // 防止同样参数请求两次
    if (JSON.stringify({ ...this.selectTime }) === JSON.stringify(data)) return;
    this.selectTime = data || {};
  }

  /** 获取投递数据 */
  @action.bound
  setUpdateTime(str: string) {
    this.timeStr = str;
  }

  /** 设置选中的天下标 */
  @action.bound
  setDayIndex(num: number, isVal: boolean = false) {
    if (isVal) {
      this.dayIndex = num;
    } else {
      this.dayIndex += num;
    }
    if (this.dayIndex === 0) {
      const today = moment();
      this.days = { name: `${today.format('MM-DD')} 今天`, val: today.format('YYYY-MM-DD') };
    } else if (this.dayIndex === 1) {
      const yestoday = moment().subtract(1, 'days');
      this.days = { name: `${yestoday.format('MM-DD')} 昨天`, val: yestoday.format('YYYY-MM-DD') };
    } else {
      const day = moment().subtract(this.dayIndex, 'days');
      this.days = { name: day.format('YYYY-MM-DD dddd'), val: day.format('YYYY-MM-DD') };
    }
    const g = Number(moment(this.days.val).format('W'));
    const n = Number(moment().format('W'));
    const diff = n - g;
    this.setWeekIndex(diff, true);
  }

  /** 设置激活tab */
  @action.bound
  setTab(tab: number) {
    this.curTab = tab;
  }

  /** 设置今天 */
  @action.bound
  setToday() {
    this.dayIndex = 0;
    const today = moment();
    this.days = { name: `${today.format('MM-DD')} 今天`, val: today.format('YYYY-MM-DD') };
    this.weekIndex = 0;
    this.weeks = { name: '本周', start: thisweek[0], end: thisweek[1] };
  }

  /** 设置天的数据 */
  @action.bound
  setDays(val: string) {
    const diff = moment().diff(val, 'days');
    this.setDayIndex(diff, true);
  }

  /** 设置报告天的数据 */
  @action.bound
  setReportDay(val: string) {
    this.reportDay = val;
    // this.setDays(val);
  }

  /** 设置选中的周下标 */
  @action.bound
  setWeekIndex(num: number, isVal: boolean = false) {
    this.reportDay = '';
    if (isVal) {
      this.weekIndex = num;
    } else {
      this.weekIndex += num;
    }
    if (this.weekIndex === 0) {
      this.weeks = { name: '本周', start: thisweek[0], end: thisweek[1] };
    } else if (this.weekIndex === 1) {
      const lastweek = format.getStartEnd('lastweek');
      this.weeks = { name: '上周', start: lastweek[0], end: lastweek[1] };
    } else {
      const wks = format.getStartEnd('otherweek', this.weekIndex);
      this.weeks = { name: wks[2], start: wks[0], end: wks[1] };
    }
  }

  /** 设置周统计数据 */
  @action.bound
  setWeekData(data) {
    this.weekData = data;
  }

  /** 设置属性的值 */
  @action.bound
  setProperyVal(key, val) {
    this[key] = val;
  }

  @action.bound
  setAppLoading(val: boolean) {
    this.appLoading = val;
  }
}

export default Stats;
